import React from "react";

import { useTranslation, Trans } from "react-i18next";

import Fade from 'react-reveal/Fade';

import pass from '../../img/pass.png'

function Detailed () {

    const { t } = useTranslation();
      
    return(
        <div className="overflow-hidden relative max-w-[1220px] mx-[20px] xl:mx-auto mt-[80px] xl:mt-[120px]">
            <div className="flex flex-col xl:flex-row justify-between items-center">
                <div className="xl:max-w-[550px]">
                    <p className="manrope text-[20px] xl:text-[40px] font-[500] textsp leading-[1.2] text-black"><Trans>{t('home.5')}</Trans></p>
                    <table className="min-w-full table-auto border-collapse mt-[20px] xl:mt-[40px] ">
                        <tbody>
                            <tr>
                                <td className="text-[#000000B2] py-2 opacity-[0.7] text-[14px] roboto align-top">{t('home.6')}</td>
                                <td className="text-black opacity-[0.7] roboto font-[500] text-[14px] xl:max-w-[360px]">{t('home.13')}</td>
                            </tr>
                            <tr>
                                <td className="text-[#000000B2] py-2 opacity-[0.7] text-[14px] roboto align-top">{t('home.7')}</td>
                                <td className="text-black opacity-[0.7] roboto font-[500] text-[14px] xl:max-w-[360px]">{t('home.14')}</td>
                            </tr>
                            <tr>
                                <td className="text-[#000000B2] py-2 opacity-[0.7] text-[14px] roboto align-top">{t('home.8')}</td>
                                <td className="text-black opacity-[0.7] roboto font-[500] text-[14px] xl:max-w-[360px]">{t('home.15')}</td>
                            </tr>
                            <tr>
                                <td className="text-[#000000B2] py-2 opacity-[0.7] text-[14px] roboto align-top">{t('home.9')}</td>
                                <td className="text-black opacity-[0.7] roboto font-[500] text-[14px] xl:max-w-[360px]">{t('home.16')}</td>
                            </tr>
                            <tr>
                                <td className="text-[#000000B2] py-2 opacity-[0.7] text-[14px] roboto align-top">{t('home.10')}</td>
                                <td className="text-black opacity-[0.7] roboto font-[500] text-[14px] xl:max-w-[360px]">{t('home.17')}</td>
                            </tr>
                            <tr>
                                <td className="text-[#000000B2] py-2 opacity-[0.7] text-[14px] roboto align-top">{t('home.11')}</td>
                                <td className="text-black opacity-[0.7] roboto font-[500] text-[14px] xl:max-w-[360px]">{t('home.18')}</td>
                            </tr>
                            <tr>
                                <td className="text-[#000000B2] py-2 opacity-[0.7] text-[14px] roboto align-top">{t('home.12')}</td>
                                <td className="text-black opacity-[0.7] roboto font-[500] text-[14px] xl:max-w-[360px]"><Trans>{t('home.19')}</Trans></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <Fade><img src={pass} alt="" className="mt-[20px] xl:mt-0"/></Fade>
            </div>
        </div>
    );
}

export default Detailed;